import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { BookingDeviceModalMode, Device } from '../types';
import { toTitleCase } from '@shared/utils/utilsOld';
import { formatBookingRange } from '@pages/booking/utils';

interface BookingDeviceModalHeaderProps {
    mode: BookingDeviceModalMode;
    selectedDevice?: Device;
    futureBookingFrom?: string;
    futureBookingTo?: string;
}

const BookingDeviceModalHeader: FC<BookingDeviceModalHeaderProps> = ({
    mode,
    selectedDevice,
    futureBookingFrom,
    futureBookingTo,
}) => {
    const { t } = useTranslation();
    const futureBookingFromDate = futureBookingFrom && new Date(futureBookingFrom);
    const futureBookingToDate = futureBookingTo && new Date(futureBookingTo);

    return (
        <DialogTitle sx={{ display: 'flex', flexDirection: 'column', padding: '16px 24px' }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: 'var(--text-secondary)',
                }}
            >
                <Typography sx={{ fontWeight: 600, fontSize: '0.75rem' }}>
                    {mode === BookingDeviceModalMode.VIEW ? toTitleCase(selectedDevice?.type) : t('booking')}
                </Typography>
                <Typography sx={{ fontWeight: 600, fontSize: '0.75rem' }}>
                    {mode === BookingDeviceModalMode.VIEW
                        ? selectedDevice?.office !== '' && t('location')
                        : t('duration')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '1rem' }}>
                {selectedDevice && (
                    <>
                        <Typography sx={{ fontSize: '1rem' }}>
                            {mode === BookingDeviceModalMode.VIEW
                                ? `${selectedDevice.name}`
                                : `${selectedDevice.name} ${selectedDevice.office || ''}`}
                        </Typography>
                        <Typography sx={{ fontSize: '1rem' }}>
                            {mode === BookingDeviceModalMode.VIEW
                                ? `${selectedDevice.office}`
                                : formatBookingRange(futureBookingFromDate as Date, futureBookingToDate as Date)}
                        </Typography>
                    </>
                )}
            </Box>
        </DialogTitle>
    );
};

export default BookingDeviceModalHeader;
